import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { RouterLink } from '@angular/router';
import { PageHeader } from '../../../shared/page-header/page-header';
import { Pagination } from '../../../shared/pagination/pagination';
import { AuthService } from '../../../core/auth/auth.service';
import { OrganizationService } from '../../../core/organization/organization.service';
import { Organization } from '../../../core/organization/organization.models';

@Component({
  selector: 'app-organization-list',
  imports: [RouterLink, FormsModule, DatePipe, PageHeader, Pagination],
  templateUrl: './organization-list.html',
})
export class OrganizationList implements OnInit {
  private readonly service = inject(OrganizationService);
  protected readonly auth = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly search$ = new Subject<void>();
  private fetching?: Subscription;

  protected readonly organizations = signal<Organization[]>([]);
  protected readonly loading = signal(true);
  protected readonly error = signal<string | null>(null);

  protected q = '';
  protected readonly pageSize = 10;
  protected readonly page = signal(1);
  protected readonly total = signal(0);

  ngOnInit(): void {
    this.search$.pipe(debounceTime(300), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.load());
    this.load();
  }

  /** A escrita espera 300 ms e o pedido anterior é cancelado: nada de um pedido por tecla. */
  protected onSearch(): void {
    this.search$.next();
  }

  protected load(): void {
    this.page.set(1);
    this.fetch();
  }

  protected onPage(p: number): void {
    this.page.set(p);
    this.fetch();
  }

  private fetch(): void {
    this.loading.set(true);
    this.error.set(null);
    this.fetching?.unsubscribe();
    this.fetching = this.service.list({ q: this.q, page: this.page() - 1, size: this.pageSize }).subscribe({
      next: (res) => {
        this.organizations.set(res.content);
        this.total.set(res.totalElements);
        this.loading.set(false);
      },
      error: () => {
        this.error.set('Não foi possível carregar as organizações.');
        this.loading.set(false);
      },
    });
  }
}
